import { DestinationTreeState } from "../objects/destinationTreeState";
import { DestinationTreeActionTypes, SET_DESTINATIONS, SET_EDIT_TREE } from "./actionTypes";

const initialState: DestinationTreeState = {
    destinations: [],
    edit_tree: false
};

export default (state: DestinationTreeState = initialState, action: DestinationTreeActionTypes): DestinationTreeState => {
    switch (action.type) {
        case SET_DESTINATIONS: {
            return {...state, destinations: action.payload};
        }
        case SET_EDIT_TREE: {
            return {...state, edit_tree: action.payload};
        }
        default:
            return state;
    }
}